import Environment from './environment';
import {
    getParam
} from './utils';
import LocalStorage from './local-storage';
import $ from 'cash-dom';
import * as form from './form';
import {
    getFingerprint
} from './utils';
import {
    validatePhone,
    validateEmail
} from './form';
import {
    _html as html
} from './html';

let fp = '';

getFingerprint().then(id => {
    fp = id;
});

export default class Auth {
    constructor(Options, html, api, local, checkError) {
        this.Options = Options;
        this.Facebook = Options.Facebook;
        this.Zalo = Options.Zalo;
        this.Google = Options.Google;
        this.Wheel = Options.Wheel;
        this.html = html;
        this.api = api;
        this.checkError = checkError;
        this.local = local;
        this.error = false;
        this.id = 'auth-' + Date.now();
    }
    loginFB(state = '', cb) {
        const {
            APP_ID,
            FACEBOOK_REDIRECT_URI
        } = this.Facebook;
        var url = [
            "https://www.facebook.com/v2.12/dialog/oauth?client_id=", APP_ID,
            "&redirect_uri=", FACEBOOK_REDIRECT_URI,
            state ? '&state=' + state : ''
        ].join("");

        this.openLoginWindow(url, function (err, data) {
            cb(data);
        });
    }

    loginZalo(state = '', cb) {
        const {
            APP_ID,
            ZALO_REDIRECT_URI
        } = this.Zalo;
        var url = [
            "https://oauth.zaloapp.com/v3/permission?app_id=", APP_ID,
            "&redirect_uri=", ZALO_REDIRECT_URI,
            state ? '&state=' + state : ''
        ].join("");

        this.openLoginWindow(url, function (err, data) {
            ('data', data);
            cb(data);
        });
    }

    loginGoogle(state = '', cb) {
        const {
            APP_ID,
            GOOGLE_REDIRECT_URI
        } = this.Google;
        var url = [
            "https://accounts.google.com/o/oauth2/v2/auth?client_id=", APP_ID,
            "&response_type=code",
            "&scope=https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email",
            "&access_type=offline",
            "&redirect_uri=", GOOGLE_REDIRECT_URI,
            state ? '&state=' + state : ''
        ].join("");

        this.openLoginWindow(url, function (err, data) {
            cb(data);
        });
    }
    openLoginWindow(url, callback) {
        if (Environment.isMobile()) {
            return this.redirectForMobile(url);
        }
        let redirectUrl = url.split('&').find(p => p.startsWith('redirect_uri='));
        redirectUrl = decodeURIComponent(redirectUrl.replace('redirect_uri=', ''));
        window.open(url, "_blank", "width=700,height=500,left=200,top=100");
        window.addEventListener(
            "message",
            (evt) => {
                if (!redirectUrl.startsWith(evt.origin)) return;
                var data = {};
                try {
                    data = JSON.parse(evt.data);
                    callback(null, data);
                } catch (err) {
                    callback(err, null)
                };
            },
            false
        );
    }

    redirectForMobile(url) {
        // make sure url has state=something
        if (url.indexOf('state=') == -1) {
            url += '&state=dummy';
        }
        const {
            origin,
            pathname,
            search
        } = window.location;
        let currentEnUrl = encodeURIComponent(origin + pathname + search);

        let stateStr = getParam('state', url);
        let state = {};
        if (stateStr != 'dummy') {
            try {
                state = JSON.parse(atob(stateStr));
                state.redirect = currentEnUrl;
            } catch (e) {
                console.log('state lỗi', e);
            }
        }
        // fix url has hash (#)
        if (!state.redirect) {
            window.location.href = url.replace(stateStr, 'redirect_' + currentEnUrl);
            return;
        }
        let newStateStr = btoa(JSON.stringify(state));
        window.location.href = url.replace(stateStr, newStateStr);
    }

    async verifyPlayCode(playCode, cb) {
        try {
            const data = await this.api.loginPlayCode(playCode);
            this.html.closeAllModal('auth:verifyPlayCode:124');
            cb(data);
            return data;
        } catch (e) {
            // TODO: fix checkError(e)
            // throw e;
            this.checkError(e);
        }
    }

    async verifyNoAuth(d, cb) {
        try {
            // console.log('this', this, this.id);
            this.html.showLoading();
            const data = await this.api.loginNoAuth(d);
            // console.log('verifyNoAuth', data);
            await cb(data);
            this.html.hideLoading();
            this.html.closeAllModal('auth:138');
            this.error = false;
        } catch (e) {
            console.log(e);
            // TODO: fix checkError(e)
            // throw e;
            this.error = true;
            this.checkError(e);
        }
    }

    checkLoginWithManychat(cb) {
        const mcp_token = getParam('mcp_token');
        if (!mcp_token) {
            return;
        };
        // const pid = getParam('pid'),
        const id = getParam('uid'),
            name = getParam('uname'),
            phone = getParam('uphone'),
            email = getParam('uemail');
        const data = {
            id
        }
        if (name) {
            data.name = name;
        }
        if (phone && validatePhone(phone)) {
            data.phone = phone;
        }
        if (email && validateEmail(email)) {
            data.email = email;
        }
        this.verifyManyChat(data, cb);
    }

    async verifyManyChat(d, cb) {
        try {
            if (!d.id) {
                return;
            }
            const data = await this.api.loginManyChat(d)
            cb(data);
            this.html.hideLoading();
        } catch (e) {
            this.checkError(e)
        }
    }

    checkLoginWithHaravan() {
        const phone = getParam('phone');
        const orderNumber = getParam('order_number');
        const data = {};
        if (phone) {
            data.phone = phone;
            $('#w-play-code-haravan .w-verify_phone').val(data.phone);
        }
        if (orderNumber) {
            data.order_number = orderNumber;
            $('#w-play-code-haravan .w-verify_order_number').val(data.order_number);
        }
        console.log('data', data);
    }

    async verifyLoginHaravan(phone, orderNumber, orderId, cb) {
        try {
            console.log({
                phone,
                orderNumber,
                orderId
            })
            const data = await this.api.loginHaravan(phone, orderNumber, orderId);
            this.html.closeAllModal('auth:verifyLoginHaravan:124');
            cb(data);
            return data;
        } catch (e) {
            this.checkError(e)
        }
    }


    checkLoginWithSapo() {
        const phone = getParam('phone');
        const orderNumber = getParam('order_number');
        const orderId = getParam('order_id');
        const data = {};
        if (phone) {
            data.phone = phone;
            $('#w-play-code-sapo .w-verify_phone').val(data.phone);
        }
        if (orderNumber) {
            data.order_number = orderNumber;
            $('#w-play-code-sapo .w-verify_order_number').val(data.order_number);
        }
        if (orderId) {
            console.log('have orderId');
            $('#w-play-code-sapo .w-verify_order_number').parent('.w-form-group').css('display', 'none');
        } else {
            $('#w-play-code-sapo .w-verify_order_number').parent('.w-form-group').css('display', 'block');
        }
        console.log('data', data);
    }

    async verifyLoginSapo(phone, orderNumber, orderId, cb) {
        try {
            const data = await this.api.loginSapo(phone, orderNumber, orderId);
            this.html.closeAllModal('auth:verifyLoginHaravan:124');
            cb(data);
            return data;
        } catch (e) {
            this.checkError(e)
        }
    }


    checkAuthParam(cb) {
        setTimeout(_ => {
            // TODO: Bật tắt lấy wauth từ param hoặc cookie
            let wauth = getParam('wauth');
            let method = 'query';
            let user;
            const scheme = this.Wheel.scheme;
            const ignore_wauth_cookie = this.Options.ignore_wauth_cookie;

            //TODO: sẽ tìm cách sử dụng lại ignore wauth_cookie
            let shouldLoadFromLocal = !wauth && !ignore_wauth_cookie;
            shouldLoadFromLocal = shouldLoadFromLocal && ['tour', 'mixed'].includes(scheme);
            if (shouldLoadFromLocal) {
                wauth = this.local.get('wauth');
                method = 'localStorage';
            }
            if (wauth) {
                let jwt = wauth;
                if (method == 'localStorage') {
                    const userInfo = this.local.get('userInfo');
                    try {
                        user = JSON.parse(JSON.stringify(userInfo));
                    } catch (e) {
                        console.log(e);
                    }
                }
                if (!user) {
                    user = this.parseJwt(jwt)
                }
                user = Object.assign({}, user, {
                    jwt
                });
                cb(user, method);
            }
        }, 200);
    }
    parseJwt(jwt) {
        let encoded = jwt.split('.')[1];
        encoded = encoded.replace(/\-|_|,/g, '/');
        let data = {};
        try {
            data = JSON.parse(decodeURIComponent(escape(atob(encoded))));
        } catch (e) {

        }
        return data;
    }

    loginHandler() {
        console.log('loginHandler');
        const login_method = this.Wheel.login_method;

        if (login_method == 'no_auth' || login_method == 'password') {
            console.log('login noauth or password');
            this.html.pushModal('modal-woay-userinfo');
        }

        if (login_method === 'haravan_order') {
            this.html.pushModal('w-play-code-haravan');
        }

        if (login_method === 'sapo_order') {
            this.html.pushModal('w-play-code-sapo');
        }

        if (login_method === 'play_code') {
            this.html.pushModal('w-play-code');
        }
        if (login_method === 'facebook') {
            console.log('login fb');
            this.html.pushModal('w-verify');
        }

        if (login_method === 'zalo') {
            this.html.pushModal('w-verify-zalo');
        }

        if (login_method === 'google') {
            this.html.pushModal('w-verify-google');
        }
        console.log('finish loginHandler');
    }

    loginAfterInfoForm() {
        const login_method = this.Wheel.login_method;
        return (login_method === 'no_auth' || login_method === 'password');
    }

    loginBeforeInfoForm() {
        return !this.loginAfterInfoForm(this.Wheel);
    }

    isUserEnoughData(_userInfo) {
        // console.log('isUserEnoughData', _userInfo);
        const form = this.Wheel.form;
        const keys = Object.keys(form).filter(key => form[key].enabled);
        console.log('keys', keys);
        const data = _userInfo;
        const metaStr = data.meta || '';
        const metaLines = metaStr.split('&');
        const meta = {}
        metaLines.forEach(line => {
            const [key, value] = line.split('=');
            meta[key] = value;
            const target = keys.find(k => form[k] && form[k].name == key);
            // console.log('findTarget', {
            //     key,
            //     value,
            //     target
            // })
            if (target) {
                data[target] = value;
            }
        })
        const mergedData = Object.assign({}, _userInfo, data);
        for (let key of keys) {
            if (form[key].required && !mergedData[key] && key != 'password') {
                console.log('mergedData', key, mergedData);
                return false;
            }
        }
        return true;
    }

    handleLoginButtons(verifyLoginDone, updateInfoAfterLogin) {
        const login_method = this.Wheel.login_method;

        var url_string = window.location.href
        var url = new URL(url_string);
        var code = url.searchParams.get("code");
        if(code){
            this.verifyPlayCode(code, verifyLoginDone);
        }

        $(document).on('click', '#w-play-code-submit-btn', () => {
            $('#w-play-code .w-form-group').removeClass('error');
            var playCode = $('.w-verify_code').val();
            
            if (!playCode) {
                $('#w-play-code .w-verify_code').parent().addClass('error');
                return;
            }
            this.verifyPlayCode(playCode, verifyLoginDone);
        })

        $(document).on('click', '#w-play-code-haravan-submit-btn', () => {
            $('#w-play-code-haravan .w-form-group').removeClass('error');
            var phone = $('.w-verify_phone').val();
            var orderNumber = $('.w-verify_order_number').val();
            var orderId = getParam('order_id');
            if (!phone) {
                $('#w-play-code-haravan .w-verify_phone').parent().addClass('error');
                return;
            }
            if (phone.charAt(0) == '0') {
                console.log('get phone đầu = 0');
                let oldPhoneString = phone.substring(1);
                phone = '+84' + oldPhoneString;
            }
            if (!orderNumber) {
                $('#w-play-code-haravan .w-verify_order_number').parent().addClass('error');
                return;
            }
            this.verifyLoginHaravan(phone, orderNumber, orderId, verifyLoginDone);
        })


        $(document).on('click', '#w-play-code-sapo-submit-btn', () => {
            $('#w-play-code-sapo .w-form-group').removeClass('error');
            var phone = $('.w-verify_phone').val();
            var orderNumber = $('.w-verify_order_number').val();
            var orderId = getParam('order_id');
            if (!phone) {
                $('#w-play-code-sapo .w-verify_phone').parent().addClass('error');
                return;
            }
            if (phone.charAt(0) == '0') {
                console.log('get phone đầu = 0');
                let oldPhoneString = phone.substring(1);
                phone = '+84' + oldPhoneString;
            }
            if (!orderNumber && !orderId) {
                $('#w-play-code-sapo .w-verify_order_numer').parent().addClass('error');
                return;
            }
            this.verifyLoginSapo(phone, orderNumber, orderId, verifyLoginDone);
        })

        // Handle click login FB
        $(document).on('click', '#w-verify-submit-btn', () => {
            this.html.closeAllModal('auth:346');
            var str = JSON.stringify({
                game_uid: this.Wheel.WHEEL_ID,
                key: fp
            });
            var state = btoa(str);
            this.loginFB(state, verifyLoginDone);
        })

        $(document).on('click', '#w-verify-login-zalo', () => {
            this.html.closeAllModal('auth:357');
            var str = JSON.stringify({
                game_uid: this.Wheel.WHEEL_ID,
                key: fp
            });
            var state = btoa(str);
            this.loginZalo(state, verifyLoginDone);
        })

        $(document).on('click', '#w-verify-login-google', () => {
            this.html.closeAllModal('auth:368');
            var str = JSON.stringify({
                game_uid: this.Wheel.WHEEL_ID,
                key: fp
            });
            var state = btoa(str);
            this.loginGoogle(state, verifyLoginDone);
        })

        $(document).on('click', '#btn-woay-form-submit', () => {
            form.handleInfoForm('modal-woay-userinfo', async (error, formData) => {
                if (error) return;
                if (login_method == 'no_auth' || login_method == 'password') {
                    await this.verifyNoAuth(formData, verifyLoginDone);
                }
                if (this.error) return;
                console.log('update success updateInfoAfterLogin', formData);
                updateInfoAfterLogin(formData);
            })
        });
    }

    saveRefFactory() {
        return function () {
            var refId = getParam("wref");
            var oldRef = this.local.get("wref");
            // Don't override ref & prevent self-ref
            if (refId && !oldRef) {
                local.set("wref", refId, 7);
            }
        }
    }
}